import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BINARIES_FEATURE_KEY, BinariesFeatureState } from '../reducers';

const binariesFeatureState =
  createFeatureSelector<BinariesFeatureState>(BINARIES_FEATURE_KEY);

export const isUploading = createSelector(
  binariesFeatureState,
  (state: BinariesFeatureState) => state.binaries.isUploading
);
